(function () {
  'use strict';

  function customClickOutside($document) {
      return {
          restrict: 'A',
          scope: {
            clickOutside: '&customClickOutside',
            clickOutsideSelector: '@',
            clickOutsideIgnoreSelector: '@'
          },
          link: function (scope) {
            var handler = function (event) {
              var ignoreElement = $(scope.clickOutsideIgnoreSelector);
              if (!ignoreElement.length) {
                return;
              }

              if (ignoreElement === event.target || ignoreElement[0].contains(event.target)) {
                  // do nothing
                  return;
              }

              var element = $(scope.clickOutsideSelector);
              if (!element[0]) {
                return;
              }
              if (element !== event.target && !element[0].contains(event.target)) {
                  scope.$applyAsync(function () {
                      scope.clickOutside();
                  });
              }
            };

            // Might not work on elements that stop events from bubbling up
            $document.on('click', handler);

            // Clean up event so it does not keep firing after leaving scope
            scope.$on('$destroy', function() {
                $document.off('click', handler);
            });
          }
      }
  }

  customClickOutside.$inject = ['$document'];

  angular.module('ecap.common').directive('customClickOutside', customClickOutside);
})();